import React from 'react';
import { AwardIcon, CheckCircle2Icon, HardHatIcon, UsersIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useCountUp } from '../hooks/useCountUp';
import { Mascot } from './Mascot';
import type { StatItem } from '../types/copy';
const icons: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  years: HardHatIcon,
  projects: CheckCircle2Icon,
  inhouse: UsersIcon,
  licensed: AwardIcon
};
function StatValue({
  value
}: {
  value: string;
}) {
  const numeric = /^(\d+)\+$/.exec(value);
  const target = numeric ? Number(numeric[1]) : 0;
  const {
    ref,
    value: current
  } = useCountUp(target);
  if (!numeric) {
    return <span className="font-display text-2xl font-extrabold sm:text-3xl" data-id="element-356" data-mp="1lybiej8w4fv3">{value}</span>;
  }
  return <span ref={ref} className="font-display text-4xl font-extrabold sm:text-[42px]" data-id="element-357" data-mp="5k1svlswwl2o">
      {current}+
    </span>;
}
function Stat({
  item
}: {
  item: StatItem;
}) {
  const Icon = icons[item.id] ?? CheckCircle2Icon;
  return <li className="flex items-center gap-4 text-ink" data-id="element-358" data-mp="1ai5aq3ngup00">
      <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded bg-ink/90" data-id="element-359" data-mp="1akzxi1tyclwl">
        <Icon className="h-6 w-6 text-gold-500" data-id="element-360" data-mp="16joeif5l2yxd" />
      </span>
      <span className="flex flex-col leading-tight" data-id="element-361" data-mp="1khw7kbzi1g39">
        <StatValue value={item.value} data-id="element-362" data-mp="1fi04qg2jfupa" />
        <span className="mt-1 text-[13px] font-bold uppercase tracking-wider text-ink/75" data-id="element-363" data-mp="1fgytaahm1671">
          {item.label}
        </span>
      </span>
    </li>;
}
export function TrustBar() {
  const {
    t
  } = useLanguage();
  return <section aria-label={t.trust.note} className="relative w-full overflow-hidden bg-brand-500" data-id="element-364" data-mp="1pfxqmwwxdfeq">
      <div className="h-1.5 w-full bg-gold-500" aria-hidden="true" data-id="element-365" data-mp="236sz483ihuhs" />
      <div className="mx-auto max-w-shell px-4 py-10 sm:px-6 lg:px-8 lg:py-12" data-id="element-366" data-mp="1y9j48cxcsqmk">
        <ul className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6" data-id="element-367" data-mp="2d58qmc6gb5rt">
          {t.trust.items.map(item => <Stat key={item.id} item={item} data-id="element-368" data-mp="2888na90zkh4e" />)}
        </ul>
        <p className="mt-8 flex items-center gap-3 border-t border-ink/15 pt-6 text-sm font-semibold text-ink/80" data-id="element-369" data-mp="2fan8xjmtatkw">
          <Mascot size={36} tone="light" animate data-id="element-370" data-mp="2ka04csrr18z3" />
          {t.trust.note}
        </p>
      </div>
    </section>;
}